var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,10.1c-0.3,0-0.5-0.2-0.5-0.5V4.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v5.4 C8.5,9.9,8.3,10.1,8,10.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,12.3c-0.1,0-0.3-0.1-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0.2-0.2,0.5-0.2,0.7,0 c0,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.3-0.2,0.4C8.3,12.3,8.1,12.3,8,12.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,16c-0.5,0-1.1-0.2-1.5-0.5c0,0,0,0,0,0c-2.1-1.7-4.4-4-6-6c-0.7-1.1-0.7-2.3,0-3c1.6-2,3.9-4.3,6-6 c0.8-0.7,2.1-0.7,3,0c2.1,1.7,4.4,4,6,6c0.7,0.8,0.7,2.1,0,3c-1.7,2.1-4,4.4-6,6C9.1,15.8,8.5,16,8,16z M7.1,14.7 c0.5,0.4,1.3,0.4,1.8,0c2-1.6,4.2-3.9,5.9-5.9c0.4-0.5,0.4-1.3,0-1.8c-1.6-2-3.9-4.2-5.9-5.9c-0.5-0.4-1.3-0.4-1.8,0 c-2,1.6-4.2,3.9-5.9,5.9c-0.4,0.4-0.4,1.2,0,1.8C2.9,10.9,5.1,13.1,7.1,14.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTask);
export default __webpack_public_path__ + "static/media/failed-task.3f7b58dd3517098e99713e81e08a808e.svg";
export { ForwardRef as ReactComponent };